import React from 'react';
import { formatCents } from '../../utils/subscriptionFormat';
import styles from './PlanHeroCard.module.css';

const TRIAL_TOTAL_DAYS = 30;

const shortDate = (value) => new Date(value).toLocaleDateString('pt-BR');

// Blocos de datas do card principal: próxima cobrança, fim do acesso, fim do teste
const buildFacts = ({ kind, status, subscription, nextCharge, trialEndsLabel }) => {
  const facts = [];
  const dueLabel = subscription?.next_due_date_formatted;

  if (kind === 'active') {
    if (status === 'canceling') {
      if (dueLabel) facts.push({ label: 'Acesso até', value: dueLabel });
    } else if (subscription?.next_due_date) {
      facts.push({
        label: status === 'trialing' ? 'Primeira cobrança' : 'Próxima cobrança',
        value: dueLabel || 'Não disponível',
        // Valor pela prévia do Stripe (crédito já descontado: troca de plano ou Indique e ganhe)
        amount: nextCharge ? formatCents(nextCharge.nextChargeCents) : null,
        hint: nextCharge?.creditCents > 0
          ? `Crédito de ${formatCents(nextCharge.creditCents)} já descontado.`
          : null,
      });
    }
    const trialEndsAt = subscription?.trial_ends_at;
    if (trialEndsAt && new Date(trialEndsAt) > new Date()) {
      facts.push({ label: 'Teste termina em', value: shortDate(trialEndsAt) });
    }
  }

  if (kind === 'canceled') {
    // next_due_date vira NULL no encerramento; canceled_at guarda o fim do acesso
    const until = subscription?.next_due_date_formatted || subscription?.canceled_at_formatted;
    if (until) facts.push({ label: 'Acesso até', value: until });
  }

  if (kind === 'internalTrial' && trialEndsLabel) facts.push({ label: 'Termina em', value: trialEndsLabel });
  if (kind === 'trialExpired' && trialEndsLabel) facts.push({ label: 'Encerrado em', value: trialEndsLabel });

  return facts;
};

const PlanHeroFacts = ({ trialDaysRemaining, ...props }) => {
  const facts = buildFacts(props);
  const showTrialProgress = props.kind === 'internalTrial';
  if (!facts.length && !showTrialProgress) return null;

  const usedDays = Math.max(0, TRIAL_TOTAL_DAYS - trialDaysRemaining);

  return (
    <div className={styles.facts}>
      {facts.map((fact) => (
        <div key={fact.label} className={styles.fact}>
          <span className={styles.factLabel}>{fact.label}</span>
          <span className={styles.factValue}>
            {fact.value}
            {fact.amount && <span className={styles.factAmount}>{fact.amount}</span>}
          </span>
          {fact.hint && <span className={styles.factHint}>{fact.hint}</span>}
        </div>
      ))}
      {showTrialProgress && (
        <div className={`${styles.fact} ${styles.factWide}`}>
          <span className={styles.factLabel}>Dias de teste</span>
          <div className={styles.trialTrack}>
            <div
              className={styles.trialFill}
              style={{ width: `${Math.min((usedDays / TRIAL_TOTAL_DAYS) * 100, 100)}%` }}
            />
          </div>
          <span className={styles.factHint}>
            {trialDaysRemaining === 1
              ? 'Seu teste termina amanhã'
              : `${usedDays} de ${TRIAL_TOTAL_DAYS} dias utilizados`}
          </span>
        </div>
      )}
    </div>
  );
};

export default PlanHeroFacts;
